/**
 * VisionENSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait VisionENSiteHeaderLanguages
 */

import { useVisionENSiteHeaderLanguagesLogic } from '@/hooks/traits/useVisionENSiteHeaderLanguagesLogic';
import type { VisionENSiteHeaderLanguagesConfig } from '@/hooks/traits/useVisionENSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { VisionENVisionView as VisionENVisionViewEntity } from '@app/shared';
import { Menu } from '@almadar/ui/components';
import { Button } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface VisionENSiteHeaderLanguagesViewProps {
  config?: Partial<VisionENSiteHeaderLanguagesConfig>;
}

export function VisionENSiteHeaderLanguagesView({ config: propsConfig }: VisionENSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useVisionENSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['VisionENVisionView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="VisionEN" trait="VisionENSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu trigger={<Button icon="globe" label={String(__locale.toUpperCase())} size="sm" variant="ghost" />} position="bottom-end" className={((([{ code: "en" as const, label: "English" as const, href: "/vision" as const }, { code: "ar" as const, href: "/ar/vision" as const, label: "العربية" as const }, { code: "sl" as const, label: "Slovenščina" as const, href: "/sl/vision" as const }]).length === 0)) ? "hidden" : ""} items={Array.isArray(([{ label: "English" as const, href: "/vision" as const, code: "en" as const }, { code: "ar" as const, label: "العربية" as const, href: "/ar/vision" as const }, { href: "/sl/vision" as const, code: "sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) ? (((([{ label: "English" as const, href: "/vision" as const, code: "en" as const }, { code: "ar" as const, label: "العربية" as const, href: "/ar/vision" as const }, { href: "/sl/vision" as const, code: "sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} />) : null}
    </TraitScopeProvider>
  );
}

export default VisionENSiteHeaderLanguagesView;
